/* eslint-disable no-console */
/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */
import onDOMReady from '../js/utils/onDomReady';

import './mobile-header/primary-links/c-primary-links';
import './mobile-header/mobile-nav-trigger/c-mobile-nav-trigger';
import './mobile-header/mobile-nav-tabs/c-mobile-nav-tabs';
import './mobile-header/mobile-search-trigger/c-mobile-search-trigger';
import './mobile-header/mobile-search/c-mobile-search';
// import './investment-returns-table/c-investment-returns-table';
// import './tiles/c-biography-tile';

onDOMReady(() => {
    if (document.querySelector('.c-back-to-top')) {
        import('./back-to-top/c-back-to-top').then(() => {
            console.info('Loaded JS: ./back-to-top/c-back-to-top');
        });
    }
    if (document.querySelector('.c-accordion')) {
        import('./accordion/c-accordion').then(() => {
            console.info('Loaded JS: ./accordion/c-accordion');
        });
    }
    if (document.querySelector('.print-control')) {
        import('./print-social-share/c-print-social-share').then(() => {
            console.info('Loaded JS: ./print-social-share/c-print-social-share');
        });
    }
    if (document.querySelector('.js-search-bar-trigger')) {
        import('./search-bar/c-search-bar').then(() => {
            console.info('Loaded JS: ./search-bar/c-search-bar');
        });
    }
    if (document.querySelector('.c-slider')) {
        import('./slider/c-slider-configs').then(() => {
            console.info('Loaded JS: ./slider/c-slider-configs');
        });
    }
    if (document.querySelector('.js-open-modal') || document.querySelector('.js-accept-decline-magnific-modal')) {
        import('./modal/c-modal').then(() => {
            console.info('Loaded JS: ./modal/c-modal');
        });
    }
    if (document.querySelector('.listing-app')) {
        import('./filtered-listing/c-filtered-listing').then(() => {
            console.info('Loaded JS: ./filtered-listing/c-filtered-listing');
        });
    }
    if (document.querySelector('.c-animated-tile')) {
        import('./animated-tile/c-animated-tile').then(() => {
            console.info('Loaded JS: ./animated-tile/c-animated-tile');
        });
    }
    if (document.querySelector('.js-tooltip')) {
        import('./tooltip/c-tooltip').then(() => {
            console.info('Loaded JS: ./tooltip/c-tooltip');
        });
    }
    if (document.querySelector('.c-newsletter-signup-form')) {
        import('./newsletter-signup-form/c-newsletter-signup-form').then(() => {
            console.info('Loaded JS: ./newsletter-signup-form/c-newsletter-signup-form');
        });
    }
    if (document.querySelector('.c-download-item')) {
        import('./download-item/c-download-item').then(() => {
            console.info('Loaded JS: ./download-item/c-download-item');
        });
    }
    if (document.querySelector('.c-content-tile')) {
        import('./tiles/c-content-tile').then(() => {
            console.info('Loaded JS: ./tiles/c-content-tile');
        });
    }
    if (document.querySelector('.table-responsive table') || document.querySelector('.flip-scroll table')) {
        import('./table-wrapper/c-table-wrapper').then(() => {
            console.info('Loaded JS: ./table-wrapper/c-table-wrapper');
        });
    }
});
